import { StyledGridCol, StyledGridRow } from "@/common/styles";
import Button from "@/common/elements/Button";
import { useEffect, useState } from "react";
import Modal from "@/common/elements/Modal";
import Table from "@/common/elements/Table";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import TextField from "@/common/elements/InputElements/TextField";
import Checkbox from "antd/es/checkbox/Checkbox";
import { Form, Popconfirm } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import { setBookings, setDeleteAPis } from "@/slices/bookingsSlice";
import InmateMedicationLogDetail from "./InmateMedicationLogDetail";
import CommonDatePicker from "@/common/elements/DatePicker";
import dayjs from "dayjs";
import {
  getOptionsFromRefList,
  hasCheckSecurity,
} from "@/util/common_function";
import API_ENDPOINTS from "@/util/api";
import Select from "@/common/elements/InputElements/Select";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import { Entity_types, Security_Types } from "@/util/permission_bits";
import {
  MODULES_LIST_WITH_ID,
  SUB_MODULES_LIST_WITH_ID,
} from "@/util/common_variable";

const InmateMedicationsDetails = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [isRowSelected, setIsRowSelected] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [medicationLog, setMedicationLog] = useState([]);
  const [medicationName, setMedicationName] = useState(null);
  const [filterTable, setFilterTable] = useState(false);
  const medications = useSelector(
    (state) => state?.bookings?.bookings?.medications
  );
  const { bookingsFieldsEnabled } = useSelector((state) => state?.bookings);
  const [selectedRow, setSelectedRow] = useState();
  const [showInmateMedications, setShowInmateMedications] = useState(false);
  const [isEdit, setisEdit] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);

  const clickInmateMedications = (val) => {
    setShowInmateMedications(true);
    if (val == "edit") {
      setisEdit(true);
    }
  };

  const [rowList, setRowList] = useState(medications || []);
  const [medicationList, setMedicationList] = useState();
  const [numOfBottle, setNumOfBottle] = useState(0);

  const InmateMedicationsTable = {
    headers: [
      { key: "datePrescriptionEnds", text: "Date Prescription Ends" },
      { key: "medicationName", text: "Medication Name" },
      { key: "dosage", text: "Dosage" },
      { key: "dispensingInstructions", text: "Dispensing Instructions" },
      { key: "currentlyActive", text: "Active" },
    ],
  };

  useEffect(() => {
    const tableRow = medicationList?.map((item) => {
      return {
        ...item,
        currentlyActive: item?.currentlyActive ? "Yes" : "No",
        dosage: item?.dosage || "",
      };
    });
    setRowList(tableRow);
    setFilterTable(false);
  }, [medicationList]);

  useEffect(() => {
    setMedicationList(medications || []);
  }, [medications]);

  const updateRowData = (oldData, newData) => {
    return {
      ...oldData,
      medicationLog: medicationLog,
      medicationName: newData?.medicationName,
      dosage: newData?.dosage,
      medicationType: newData?.medicationType,
      currentlyActive: newData?.currentlyActive,
      datePrescriptionEnds: newData?.datePrescriptionEnds,
      datePrescribed: newData?.datePrescribed,
      dispensingInstructions: newData?.dispensingInstructions,
    };
  };

  const saveMedicationList = () => {
    form
      .validateFields()
      .then((values) => {
        (values.datePrescriptionEnds = values?.datePrescriptionEnds
          ? dayjs(values?.datePrescriptionEnds).format("MM/DD/YYYY")
          : null),
          (values.datePrescribed = values?.datePrescribed
            ? dayjs(values?.datePrescribed).format("MM/DD/YYYY")
            : null);
        let data = "";
        if (selectedRowId) {
          data = medicationList?.map((p) =>
            p?.medicationID === selectedRowId || p?.id === selectedRowId
              ? updateRowData(p, values)
              : p
          );
        } else {
          data = [
            ...medicationList,
            {
              ...values,
              id: uuidv4(),
              dosage: values?.dosage,
              medicationLog: medicationLog,
            },
          ];
        }
        updateState(data);
        setShowInmateMedications(false);
      })
      .catch((err) => console.log(err));
  };

  const patchSelectedRow = (data) => {
    setIsRowSelected(true);
    form.setFieldsValue({
      ...data,
      currentlyActive: data?.currentlyActive === "Yes",
      datePrescriptionEnds: data?.datePrescriptionEnds
        ? dayjs(data?.datePrescriptionEnds)
        : null,
      datePrescribed: data?.datePrescribed ? dayjs(data?.datePrescribed) : null,
    });
    setSelectedRowId(data?.medicationID || data?.id);
    setSelectedRow(data);
    setMedicationLog(data?.medicationLog);
    setMedicationName(data?.medicationName);
    setNumOfBottle(data?.numberOfPillsInBottle);
  };

  const addMedication = () => {
    form.setFieldsValue({
      medicationName: null,
      dosage: null,
      currentlyActive: false,
      datePrescribed: null,
      datePrescriptionEnds: null,
      medicationType: null,
      numberOfPillsInBottle: null,
      prescribingDoctor: null,
      dispensingInstructions: null,
      specialInstructions: null,
      comments: null,
    });
    clickInmateMedications();
    setSelectedRowId(null);
    setIsRowSelected(false);
    setSelectedRow(null);
    setMedicationLog([]);
    setNumOfBottle(0);
  };

  const deleteMedication = () => {
    const tempArray = [...medicationList];
    const deleteIndex = tempArray.findIndex(
      (item) =>
        item?.medicationID === selectedRowId || item?.id === selectedRowId
    );
    tempArray.splice(deleteIndex, 1);
    setMedicationList((prev) => [...tempArray]);

    updateState(tempArray);

    const url = API_ENDPOINTS.medication + "/id/" + selectedRowId;
    dispatch(setDeleteAPis(url));
    setIsRowSelected(false);
    setSelectedRow(null);
  };

  const updateState = (data) => {
    dispatch(
      setBookings({
        medications: [...data],
      })
    );
  };

  const updateLogData = (data) => {
    const numberofPills = data?.reduce(
      (accumulator, current) => accumulator + current.numberofPills,
      0
    );
    const remainingPills =
      numOfBottle > numberofPills ? numOfBottle - numberofPills : 0;
    // setNumOfBottle(remainingPills)
    form.setFieldValue("numberofPills", remainingPills);
    setMedicationLog(data);
  };

  const filterMedicationList = (e) => {
    const tempArray = e?.target?.checked
      ? medicationList.filter((item) => item.currentlyActive)
      : medicationList;
    const tableRow = tempArray?.map((item) => {
      return { ...item, currentlyActive: item.currentlyActive ? "Yes" : "No" };
    });
    setRowList(tableRow);
    setFilterTable(e?.target?.checked);
  };

  const cancelActivation = () => {
    setShowInmateMedications(false);
    setSelectedRowId(null);
    setIsRowSelected(false);
    setSelectedRow(null);
    setMedicationLog([]);
    setFilterTable(false);
    filterMedicationList({ e: { target: { checked: false } } });
    setisEdit(false);
  };
  useEffect(() => {
    if (isEdit) {
      let isShow = hasCheckSecurity(
        Security_Types.functionality,
        Entity_types.subModule,
        LABELS_CAPITAL.MODIFY,
        MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
        SUB_MODULES_LIST_WITH_ID.Inmate_Medical
      );
      if (isShow) {
        setIsDisabled(false);
      } else {
        setIsDisabled(true);
      }
    } else {
      setIsDisabled(false);
    }
  }, [isEdit]);
  return (
    <>
      <StyledGridRow justify={"space-between"}>
        <StyledGridCol>
          <FormItem
            label="Show Current Medications Only"
            layout="horizontal"
            labelPostion="label-right"
          >
            <Checkbox
              checked={filterTable}
              onChange={filterMedicationList}
              disabled={!bookingsFieldsEnabled}
            />
          </FormItem>
        </StyledGridCol>
        <StyledGridCol>
          <Button
            onClick={addMedication}
            disabled={
              !bookingsFieldsEnabled ||
              !hasCheckSecurity(
                Security_Types.functionality,
                Entity_types.subModule,
                LABELS_CAPITAL.ADD,
                MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                SUB_MODULES_LIST_WITH_ID.Inmate_Medical
              )
            }
          >
            ADD
          </Button>
        </StyledGridCol>
        <StyledGridCol>
          <Button
            style={{ marginLeft: "10px" }}
            disabled={
              !isRowSelected ||
              rowList?.length === 0
            }
            onClick={() => clickInmateMedications("edit")}
          >
            Details
          </Button>

          <Popconfirm
            title="Delete the Inmate Medications"
            description="Are you sure to delete this Inmate Medication?"
            onConfirm={deleteMedication}
            onCancel={() => {}}
            okText="Yes"
            cancelText="No"
          >
            <Button
              color="primary"
              type="primary"
              style={{ marginLeft: "10px" }}
              disabled={
                !isRowSelected ||
                rowList?.length === 0 ||
                !bookingsFieldsEnabled
              }
            >
              Delete
            </Button>
          </Popconfirm>

          <Button
            style={{ marginLeft: "10px" }}
            onClick={cancelActivation}
            disabled={
              !isRowSelected ||
              rowList?.length === 0
            }
          >
            CANCEL
          </Button>
        </StyledGridCol>
      </StyledGridRow>

      <Modal
        header={"Inmate Medications"}
        show={showInmateMedications}
        size="xl"
        onHide={cancelActivation}
        footerActions={[
          {
            key: "save",
            text: "Save",
            onClick: saveMedicationList,
            disabled: isDisabled || !bookingsFieldsEnabled,
          },
        ]}
        footerCloseAction={() => {
          setisEdit(false);
          console.log("Close clicked");
        }}
        footerCloseActionText="Close"
      >
        <Form form={form} disabled={!bookingsFieldsEnabled}>
          <StyledGridRow gutter={16}>
            <StyledGridCol span={8}>
              <FormItem label="Medication Name" name="medicationName">
                <TextField
                  onChange={(e) => setMedicationName(e?.target?.value)}
                />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol span={8}>
              <FormItem label="Medication Type" name="medicationType">
                <Select
                  options={getOptionsFromRefList(
                    "Medication_Type",
                    false,
                    false,
                    true
                  )}
                  // onChange={(e) => {
                  //     setTimeout(() => document.activeElement.blur(), 0)
                  // }}
                  placeholder="Medication Type"
                  variant="outlined"
                  disabled={!bookingsFieldsEnabled}
                />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol span={8}>
              <FormItem label="Dosage" name="dosage">
                <TextField disabled={!bookingsFieldsEnabled} />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol span={8}>
              <FormItem
                label="Active"
                name="currentlyActive"
                valuePropName="checked"
                labelPostion="label-right"
                layout="horizontal"
                paddingTop="25px"
              >
                <Checkbox disabled={!bookingsFieldsEnabled} />
              </FormItem>
            </StyledGridCol>

            <StyledGridCol lg={6}>
              <FormItem label="Date Prescribed" name="datePrescribed">
                <CommonDatePicker
                  placeholder="MM/DD/YYYY"
                  showTime={false}
                  format="MM/DD/YYYY"
                  disabled={!bookingsFieldsEnabled}
                />
              </FormItem>
            </StyledGridCol>

            <StyledGridCol lg={6}>
              <FormItem
                label="Date Prescription Ends"
                name="datePrescriptionEnds"
              >
                <CommonDatePicker
                  placeholder="MM/DD/YYYY"
                  showTime={false}
                  format="MM/DD/YYYY"
                  disabled={!bookingsFieldsEnabled}
                />
              </FormItem>
            </StyledGridCol>

            <StyledGridCol lg={6}>
              <FormItem label="Prescribing Doctor" name="prescribingDoctor">
                <TextField />
              </FormItem>
            </StyledGridCol>

            <StyledGridCol lg={6}>
              <FormItem label="# in Bottle" name="numberofPills">
                <TextField
                  type={"number"}
                  onChange={(e) => setNumOfBottle(e?.target?.value)}
                />
              </FormItem>
            </StyledGridCol>

            <StyledGridCol lg={12}>
              <FormItem
                label="Dispensing Instructions"
                name="dispensingInstructions"
              >
                <TextField />
              </FormItem>
            </StyledGridCol>

            <StyledGridCol lg={12}>
              <FormItem label="Special Instructions" name="specialInstructions">
                <TextField />
              </FormItem>
            </StyledGridCol>

            <StyledGridCol lg={24}>
              <FormItem label="Comments" name="comments">
                <TextField inputType="textarea" rows="3" />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>
        </Form>
        <InmateMedicationLogDetail
          medicationData={selectedRow}
          numOfBottle={numOfBottle}
          medicationName={medicationName}
          updateLogData={(e) => updateLogData(e)}
        />
      </Modal>
      {hasCheckSecurity(
        Security_Types.functionality,
        Entity_types.subModule,
        LABELS_CAPITAL.VIEW,
        MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
        SUB_MODULES_LIST_WITH_ID.Inmate_Medical
      ) && (
        <Table
          headers={InmateMedicationsTable.headers}
          data={rowList}
          style={{ marginTop: "15px" }}
          onRowClick={patchSelectedRow}
          onRowDoubleClick={(data) => {
            patchSelectedRow(data);
            clickInmateMedications("edit");
          }}
          selected={selectedRow === null}
        />
      )}
    </>
  );
};

export default InmateMedicationsDetails;
